module.exports = __webpack_public_path__ + "img/dots.cc54897d.svg";